import React, { FC, HTMLAttributes } from 'react';
import { classes } from './Asterisk.st.css';

interface AsteriskProps extends HTMLAttributes<HTMLSpanElement> {
  dataHook?: string;
}

export const Asterisk: FC<AsteriskProps> = ({ dataHook, ...props }) => (
  <span
    className={classes.root}
    aria-hidden="true"
    data-hook={dataHook}
    {...props}
  >
    *
  </span>
);
